module.exports = __webpack_public_path__ + "static/media/slider-left.e64ebc9b.svg";